import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { IconButtonOwnProps } from '@mui/material';
import { BUTTON_COLORS, themeColors as COLORS } from 'toolkit/styles/colors';
import { ConfirmationAlertUniqueProps } from '../ConfirmationAlertDialog';

export const DEFAULT_DELETE_CONFIRMATION_DIALOG_CONFIG = {
  title: 'Confirm delete',
  icon: <ErrorOutlineIcon />,
  iconColor: 'error' as IconButtonOwnProps['color'],
  iconBorderColor: 'errorContainer' as keyof typeof COLORS,
  avatarCaption: 'Are you sure?',
  confirmationText: 'Yes, delete now',
  confirmButtonColor: 'error' as BUTTON_COLORS,
};

export function getDeleteConfirmationDialogConfig(
  subject: string
): ConfirmationAlertUniqueProps {
  return {
    ...DEFAULT_DELETE_CONFIRMATION_DIALOG_CONFIG,
    message: `This ${subject} will no longer be available to use for this member.`,
  };
}

export default DEFAULT_DELETE_CONFIRMATION_DIALOG_CONFIG;
